import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import {
  Bug, BookOpen, CheckSquare, Layers, GitBranch,
  ChevronsUp, ChevronUp, Minus, ChevronDown, ChevronsDown, Circle
} from "lucide-react";

const SettingsCtx = createContext(null);

const iconById = {
  epic: Layers, story: BookOpen, task: CheckSquare, bug: Bug, subtask: GitBranch,
  highest: ChevronsUp, high: ChevronUp, medium: Minus, low: ChevronDown, lowest: ChevronsDown,
};

const colorCls = {
  red: "text-red-500", orange: "text-orange-500", amber: "text-amber-500",
  emerald: "text-emerald-500", sky: "text-sky-500", purple: "text-purple-500",
  slate: "text-slate-500", gray: "text-slate-500", blue: "text-blue-500", green: "text-emerald-500",
  indigo: "text-indigo-500", pink: "text-pink-500",
};

export function decorateType(t) {
  return { ...t, label: t.name, icon: iconById[t.id] || Circle, cls: colorCls[t.color] || "text-slate-500" };
}
export function decoratePriority(p) {
  return { ...p, label: p.name, icon: iconById[p.id] || Circle, cls: colorCls[p.color] || "text-slate-500" };
}
export function decorateStatus(s) { return { ...s, label: s.name }; }

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({ statuses: [], priorities: [], issue_types: [] });
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/settings");
      setSettings(r.data);
      setLoaded(true);
      // Push into dynamic meta store for non-hook consumers (IssueCard etc.)
      try {
        const dyn = require("./metaDynamic");
        dyn.setMetaLists({
          issueTypes: (r.data.issue_types || []).map(decorateType),
          priorities: (r.data.priorities || []).map(decoratePriority),
          statuses: (r.data.statuses || []).map(decorateStatus),
        });
      } catch {}
    } catch { /* not logged in */ }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("ft_token")) refresh();
    // eslint-disable-next-line
  }, []);

  const value = {
    settings, loaded, refresh,
    statuses: (settings.statuses || []).map(decorateStatus),
    priorities: (settings.priorities || []).map(decoratePriority),
    issueTypes: (settings.issue_types || []).map(decorateType),
  };
  return <SettingsCtx.Provider value={value}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);

// Fallback lookups for helpers that still use static meta
export function findType(list, id) { const it = (list || []).find((x) => x.id === id); return it || { id, label: id, name: id, icon: Circle, cls: "text-slate-500", color: "slate" }; }
export function findPriority(list, id) { const it = (list || []).find((x) => x.id === id); return it || { id, label: id, name: id, icon: Circle, cls: "text-slate-500", color: "slate" }; }
export function findStatus(list, id) { const it = (list || []).find((x) => x.id === id); return it || { id, label: id, name: id }; }
